import {
  getAllClientsProgram,
  getUsersForBatchUploadFile,
  getUserUploadSummary,
  getUsersForPreview,
  getUserDetailForPreviewByUploadId,
  deleteUserRecordByUploadId,
  editUserRecordsByUploadId,
  addUserFileData,
  addFinalUserRecords,
  deleteAllPendingRecords,
  updateExistingUserInfo,
  uploadUserFileAllOnce,
  getuserprogramsummary,
  updateBatchUsersWithPoints,
  downloadExcelFile,
  downloadBlankTemplate,
  updateBatchUsersWithDeletePoints
} from "@/api/batch-user-upload-tool";

const adminBatchUserUploadTool = {
  namespaced: true,
  state: () => ({
    AllClientsProgram: [],
    BatchUploadUsers: [],
    AllUsersUploadSummary: [],
    AllUsersForPreview: [],
    SingleUserDetailForPreview: {},
    UsersPrograms: [],
  }),
  getters: {
    getAllClientsProgram: (state) => {
      return state.AllClientsProgram;
    },
    getAllBatchUploadUsers: (state) => {
      return state.BatchUploadUsers;
    },
    getAllBatchUserSummary: (state) => {
      return state.AllUsersUploadSummary;
    },
    getAllUsersForPreview: (state) => {
      return state.AllUsersForPreview;
    },
    getSingleUserDetailForPreview: (state) => {
      return state.SingleUserDetailForPreview;
    },
    getUsersPrograms: (state) => state.UsersPrograms,
  },
  actions: {
    fetchAllClientsProgram({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getAllClientsProgram(payload)
          .then((AllClientsProgram) => {
            commit("SET_ALL_CLIENTS_PROGRAM", AllClientsProgram);
            resolve(AllClientsProgram);
          })
          .catch((err) => {
            reject(err);
            console.log("error occured from batch user upload tool store");
          });
      });
    },

    fetchUsersForBatchUploadFile({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getUsersForBatchUploadFile(payload)
          .then((file) => {
            resolve(file);
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch upload file store action");
          });
      });
    },

    fetchUserUploadSummary({ commit }) {
      return new Promise((resolve, reject) => {
        getUserUploadSummary()
          .then((UsersUploadSummary) => {
            if (UsersUploadSummary && UsersUploadSummary.length > 0) {
              console.log(UsersUploadSummary, "from upload store");
              commit("SET_BATCH_UPLOAD_ALL_USERS_SUMMARY", UsersUploadSummary);
            } else {
              console.log(UsersUploadSummary, "from upload store");
              commit("SET_BATCH_UPLOAD_ALL_USERS_SUMMARY", []);
            }
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user summary store");
          });
      });
    },

    fetchUsersForPreview({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("SET_BATCH_UPLOAD_All_USERS_FOR_PREVIEW", []);
        getUsersForPreview(payload)
          .then((allPreviewUsers) => {
            commit("SET_BATCH_UPLOAD_All_USERS_FOR_PREVIEW", allPreviewUsers);
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user preview store");
          });
      });
    },

    fetchUserDetailForPreviewByUploadId({ commit }, payload) {
      return new Promise((resolve, reject) => {
        getUserDetailForPreviewByUploadId(payload)
          .then((uploadDetails) => {
            commit("SET_BATCH_UPLOAD_SINGLE_USER_DETAILS", uploadDetails);
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user preview upload detail store");
          });
      });
    },



    deleteUserRecordsByUploadId({ commit }, payload) {
      return new Promise((resolve, reject) => {
        deleteUserRecordByUploadId(payload)
          .then((status) => {
            console.log(status, "from store");
            if (status === 200) {
              commit("SET_BATCH_UPLOAD_SINGLE_USER_DETAILS_TO_BLANK_OBJ", {});
            }
            resolve(status);
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user preview upload delete store");
          });
      });
    },

    updateUserRecordsByUploadId({ commit }, payload) {
      return new Promise((resolve, reject) => {
        editUserRecordsByUploadId(payload)
          .then((userId) => {
            if (userId) {
              resolve(userId);
            }
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user preview upload edit store");
          });
      });
    },

    insertUserFileData({ commit }, formData) {
      return new Promise((resolve, reject) => {
        addUserFileData(formData)
          .then((status) => {
            if (status === 200) {
              resolve(status);
            }
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user upload file store");
          });
      });
    },

    insertFinalUserRecords({ commit }) {
      return new Promise((resolve, reject) => {
        addFinalUserRecords()
          .then((status) => {
            if (status === 200) {
              resolve(status);
            }
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user insert finalize user store");
          });
      });
    },

    removeAllPendingRecords({ commit }) {
      return new Promise((resolve, reject) => {
        deleteAllPendingRecords()
          .then((status) => {
            resolve(status);
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user insert finalize user store");
          });
      });
    },

    updateExistingUserInformation({ commit }) {
      return new Promise((resolve, reject) => {
        updateExistingUserInfo()
          .then((status) => {
            resolve(status);
          })
          .catch((err) => {
            reject(err);
            console.log("error from update existing user info store");
          });
      });
    },

    uploadUserFileAll({ commit }, payload) {
      return new Promise((resolve, reject) => {
        uploadUserFileAllOnce(payload)
          .then((status) => {
            resolve(status);
          })
          .catch((err) => {
            reject(err);
            console.log(
              "error from admin batch user upload uploadUserFileAll store"
            );
          });
      });
    },
    fetchUsersPrograms({ commit }) {
      return new Promise((resolve, reject) => {
        getuserprogramsummary()
          .then((UsersPrograms) => {
            console.warn(UsersPrograms);
            commit("SET_USER_PROGRAMS", UsersPrograms);
            resolve(UsersPrograms);
          })
          .catch((err) => {
            reject(err);
            console.log("error occured from batch user upload tool store");
          });
      });
    },
    updateBatchUsersWithAllPoints({ commit }) {
      return new Promise((resolve, reject) => {
        updateBatchUsersWithPoints({
          PROGRAM_ID: 0,
          PROGRAM_NAME: "",
          EMAIL_SUBJECT: "",
          EMAIL_MESSAGE: "",
        })
          .then((status) => {
            if (status === 200) {
              resolve(status);
            } else reject();
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user upload file store");
          });
      });
    },
    
    updateBatchUsersWithDeletePoints ({commit}) {
      return new Promise((resolve, reject) => {
        updateBatchUsersWithDeletePoints({
          PROGRAM_ID: 0,
          PROGRAM_NAME: "",
          EMAIL_SUBJECT: "",
          EMAIL_MESSAGE: "",
        })
          .then((status) => {
            if (status === 200) {
              resolve(status);
            } else reject("Error");
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user upload file store");
          });
      });
    },
    updateBatchUsersWithPoints({ commit }, payload) {
      return new Promise((resolve, reject) => {
        updateBatchUsersWithPoints(payload)
          .then((status) => {
            if (status === 200) {
              resolve(status);
            } else reject();
          })
          .catch((err) => {
            reject(err);
            console.log("error from batch user upload file store");
          });
      });
    },

    downloadExcelFile({ commit }, params) {
      return new Promise((resolve, reject) => {
        downloadExcelFile(params)
          .then((file) => {
            resolve(file);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "downloadExcelFile store");
          });
      });
    },

    downloadBlankTemplate({ commit }, params) {
      return new Promise((resolve, reject) => {
        downloadBlankTemplate(params)
          .then((file) => {
            resolve(file);
          })
          .catch((err) => {
            reject(err);
            console.log(err, "downloadBlankTemplate store");
          });
      });
    },
  },

  mutations: {
    SET_ALL_CLIENTS_PROGRAM: (state, AllClientsProgram) => {
      state.AllClientsProgram =
        AllClientsProgram?.length > 0 ? AllClientsProgram : [];
    },
    SET_BATCH_UPLOAD_USERS: (state, BatchUploadUsers) => {
      state.BatchUploadUsers =
        BatchUploadUsers.length > 0 ? BatchUploadUsers : [];
    },
    SET_BATCH_UPLOAD_ALL_USERS_SUMMARY: (state, UsersUploadSummary) => {
      state.AllUsersUploadSummary =
        UsersUploadSummary.length > 0 ? UsersUploadSummary : [];
    },
    SET_BATCH_UPLOAD_All_USERS_FOR_PREVIEW: (state, allPreviewUsers) => {
      state.AllUsersForPreview =
        allPreviewUsers.length > 0 ? allPreviewUsers : [];
    },
    SET_BATCH_UPLOAD_SINGLE_USER_DETAILS: (state, uploadDetails) => {
      state.SingleUserDetailForPreview = uploadDetails ? uploadDetails : {};
    },
    SET_BATCH_UPLOAD_SINGLE_USER_DETAILS_TO_BLANK_OBJ: (state, params) => {
      state.SingleUserDetailForPreview = params;
    },
    SET_USER_PROGRAMS: (state, UsersPrograms) => {
      state.UsersPrograms =
        UsersPrograms?.map(
          ({ program_id, program_name, total, totalPoints }) => ({
            id: program_id,
            program: program_name,
            users: total,
            pending_points: totalPoints,
          })
        ) ?? [];
    },
  },
};

export default adminBatchUserUploadTool;
